import { Injectable } from '@angular/core';
import { AppSettingsService } from '../appSettings/AppSettingsService';
import { ILastLoadedLocationService } from '../config/typings/services';
import { ProxyService } from '../proxy/ProxyService';
import { SearchHistoryService } from '../searchHistory/SearchHistoryService';

@Injectable({
    providedIn: 'root'
})
export class LastLoadedLocationService implements ILastLoadedLocationService {
    public static $name: string = 'lastLoadedLocationService';

    constructor(
        private appSettingsService: AppSettingsService,
        private searchHistoryService: SearchHistoryService,
        private proxyService: ProxyService
    ) {
    }

    public getLastLoadedLocationId(): number {
        const metadata = this.appSettingsService.getMetadata();

        if (metadata.lastLoadedLocationId && metadata.lastLoadedLocationId > 0) {
            return metadata.lastLoadedLocationId;
        }

        return this.getLastLoadedLocationIdFromHistory();
    }

    public updateLastLoadedLocationId(locationId: number) {
        this.updateClientLastLoadedLocationId(locationId);
        this.updateServerLastLoadedLocationId(locationId);
    }

    private getLastLoadedLocationIdFromHistory(): number {
        const searchHistory = this.searchHistoryService.getSearchHistory();

        if (searchHistory.length) {
            const firstItem = searchHistory[0];

            if (firstItem.locationId > 0) {
                return firstItem.locationId;
            }
        }

        return 0;
    }

    /* Change what we have stored locally so we can use it immediately & not worry about conflicts */
    private updateClientLastLoadedLocationId(locationId: number) {
        const metadata = this.appSettingsService.getMetadata();
        metadata.lastLoadedLocationId = locationId;
    }

    /* Change what we have stored in the database so it will be there next time we visit */
    private updateServerLastLoadedLocationId(locationId: number) {
        this.proxyService.request({
            data: {
                Entity: {
                    LocationId: locationId
                }
            },
            endPoint: 'userLastLoadedLocation',
            route: 'updateUserLastLoadedLocation',
        }).asNoContent();
    }
}
